[
    {
        "display": "true",
        "ui_columnname": "Event Type",
        "db_columnname": "type",
        "datatype": "String",
        "mappingkey": "type",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Order ID",
        "db_columnname": "orderID",
        "datatype": "String",
        "mappingkey": "orderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Order Date",
        "db_columnname": "orderKeyDate",
        "datatype": "date",
        "mappingkey": "orderKeyDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "100px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Parent Order ID",
        "db_columnname": "parentOrderID",
        "datatype": "String",
        "mappingkey": "parentOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Parent Order Date",
        "db_columnname": "parentOrderKeyDate",
        "datatype": "date",
        "mappingkey": "parentOrderKeyDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "120px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Prior Order ID",
        "db_columnname": "priorOrderID",
        "datatype": "String",
        "mappingkey": "priorOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Prior Order Date",
        "db_columnname": "priorOrderDate",
        "datatype": "date",
        "mappingkey": "priorOrderKeyDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "120px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Event Timestamp",
        "db_columnname": "eventTimestamp",
        "datatype": "String",
        "mappingkey": "eventTimestamp",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "180px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Quantity",
        "db_columnname": "quantity",
        "datatype": "Int",
        "mappingkey": "quantity",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Price",
        "db_columnname": "price",
        "datatype": "float",
        "mappingkey": "price",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Order Type",
        "db_columnname": "orderType",
        "datatype": "String",
        "mappingkey": "orderType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "TimeInForce",
        "db_columnname": "timeInForce",
        "datatype": "String",
        "mappingkey": "timeInForce",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "160px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Sender IMID",
        "db_columnname": "senderIMID",
        "datatype": "String",
        "mappingkey": "senderIMID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "100px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Destination",
        "db_columnname": "destination",
        "datatype": "String",
        "mappingkey": "destination",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "100px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Routed Order ID",
        "db_columnname": "routedOrderID",
        "datatype": "String",
        "mappingkey": "routedOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Firm Designated ID",
        "db_columnname": "firmDesignatedID",
        "datatype": "String",
        "mappingkey": "firmDesignatedID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "300px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Firm ROEID",
        "db_columnname": "firmROEID",
        "datatype": "String",
        "mappingkey": "firmROEID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "250px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Date",
        "db_columnname": "reportDate",
        "datatype": "date",
        "mappingkey": "reportDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Symbol",
        "db_columnname": "symbol",
        "datatype": "String",
        "mappingkey": "symbol",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "100px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Side",
        "db_columnname": "side",
        "datatype": "String",
        "mappingkey": "side",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Receiver IMID",
        "db_columnname": "receiverIMID",
        "datatype": "String",
        "mappingkey": "receiverIMID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "110px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Routing Origin",
        "db_columnname": "routingOrigin",
        "datatype": "String",
        "mappingkey": "routingOrigin",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "100px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Receiving DeskType",
        "db_columnname": "receivingDeskType",
        "datatype": "String",
        "mappingkey": "receivingDeskType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "160px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "LeavesQty",
        "db_columnname": "leavesQty",
        "datatype": "int",
        "mappingkey": "leavesQty",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "CancelQty",
        "db_columnname": "cancelQty",
        "datatype": "int",
        "mappingkey": "cancelQty",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Routed QuoteID",
        "db_columnname": "routedQuoteID",
        "datatype": "String",
        "mappingkey": "routedQuoteID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "BidPrice",
        "db_columnname": "bidPrice",
        "datatype": "float",
        "mappingkey": "bidPrice",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "BidQty",
        "db_columnname": "bidQty",
        "datatype": "int",
        "mappingkey": "bidQty",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "AskPrice",
        "db_columnname": "askPrice",
        "datatype": "float",
        "mappingkey": "askPrice",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "AskQty",
        "db_columnname": "askQty",
        "datatype": "float",
        "mappingkey": "askQty",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "TradeID",
        "db_columnname": "tradeID",
        "datatype": "String",
        "mappingkey": "tradeID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Buy Details",
        "db_columnname": "buyDetails",
        "datatype": "String",
        "mappingkey": "buyDetails",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Sell Details",
        "db_columnname": "sellDetails",
        "datatype": "String",
        "mappingkey": "sellDetails",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Reporting ExceptionCode",
        "db_columnname": "reportingExceptionCode",
        "datatype": "String",
        "mappingkey": "reportingExceptionCode",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "180px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Side IMID",
        "db_columnname": "sideIMID",
        "datatype": "String",
        "mappingkey": "sideIMID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Capacity",
        "db_columnname": "capacity",
        "datatype": "String",
        "mappingkey": "capacity",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "80px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "TapeTradeID",
        "db_columnname": "tapeTradeID",
        "datatype": "String",
        "mappingkey": "tapeTradeID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "MarketCenterID",
        "db_columnname": "marketCenterID",
        "datatype": "String",
        "mappingkey": "marketCenterID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "120px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Fulfillment ID",
        "db_columnname": "fulfillmentID",
        "datatype": "String",
        "mappingkey": "fulfillmentID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "130px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Client Details",
        "db_columnname": "clientDetails",
        "datatype": "String",
        "mappingkey": "clientDetails",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "100px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Firm Details",
        "db_columnname": "firmDetails",
        "datatype": "String",
        "mappingkey": "firmDetails",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "100px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Prior Fulfillment Date",
        "db_columnname": "priorFulfillmentDate",
        "datatype": "String",
        "mappingkey": "priorFulfillmentDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "180px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Prior Fulfillment ID",
        "db_columnname": "priorFulfillmentID",
        "datatype": "String",
        "mappingkey": "priorFulfillmentID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Fulfillment Link Type",
        "db_columnname": "fulfillmentLinkType",
        "datatype": "String",
        "mappingkey": "fulfillmentLinkType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "180px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Handling Instructions",
        "db_columnname": "handlingInstructions",
        "datatype": "String",
        "mappingkey": "handlingInstructions",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },{
        "display": "true",
        "ui_columnname": "AccountHolderType",
        "db_columnname": "accountHolderType",
        "datatype": "String",
        "mappingkey": "accountHolderType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "AffiliateFlag",
        "db_columnname": "affiliateFlag",
        "datatype": "Boolean",
        "mappingkey": "affiliateFlag",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Aggregated Orders",
        "db_columnname": "aggregatedOrders",
        "datatype": "String",
        "mappingkey": "aggregatedOrders",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "180px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "buyOrderID",
        "db_columnname": "buyOrderID",
        "datatype": "String",
        "mappingkey": "buyOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "sellOrderID",
        "db_columnname": "sellOrderID",
        "datatype": "String",
        "mappingkey": "sellOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "clientOrderID",
        "db_columnname": "clientOrderID",
        "datatype": "String",
        "mappingkey": "clientOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "firmOrderID",
        "db_columnname": "firmOrderID",
        "datatype": "String",
        "mappingkey": "firmOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Allocation ID",
        "db_columnname": "allocationID",
        "datatype": "String",
        "mappingkey": "allocationID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "220px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Destination Type",
        "db_columnname": "destinationType",
        "datatype": "String",
        "mappingkey": "destinationType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Manual Flag",
        "db_columnname": "manualFlag",
        "datatype": "Boolean",
        "mappingkey": "manualFlag",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Manual Order ID",
        "db_columnname": "manualOrderID",
        "datatype": "String",
        "mappingkey": "manualOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Manual OrderKeyDate",
        "db_columnname": "manualOrderKeyDate",
        "datatype": "String",
        "mappingkey": "manualOrderKeyDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "ISOInd",
        "db_columnname": "isoInd",
        "datatype": "String",
        "mappingkey": "isoInd",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Representative Ind",
        "db_columnname": "representativeInd",
        "datatype": "String",
        "mappingkey": "representativeInd",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "130px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "RouteRejected Flag",
        "db_columnname": "routeRejectedFlag",
        "datatype": "Boolean",
        "mappingkey": "routeRejectedFlag",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "130px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Solicitation Flag",
        "db_columnname": "solicitationFlag",
        "datatype": "Boolean",
        "mappingkey": "solicitationFlag",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "130px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Leg Details",
        "db_columnname": "legDetails",
        "datatype": "String",
        "mappingkey": "legDetails",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "100px",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Action Type",
        "db_columnname": "actionType",
        "datatype": "String",
        "mappingkey": "actionType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Error Code List",
        "db_columnname": "errorCodeList",
        "datatype": "String",
        "mappingkey": "errorCodeList",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "130px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Create Date",
        "db_columnname": "createDate",
        "datatype": "String",
        "mappingkey": "createDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "160px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Update Date",
        "db_columnname": "updateDate",
        "datatype": "String",
        "mappingkey": "updateDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "160px",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "User",
        "db_columnname": "lastUpdatedBy",
        "datatype": "String",
        "mappingkey": "lastUpdatedBy",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "width": "100px",
        "dropdowntype": "",
        "dropdownvalue": ""
    }
]